import { t } from "@/i18n-js/instance";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import type { Topic } from "@circle-react/types/Topic";
import { Icon } from "@circle-react-shared/Icon";
import { TippyV2 } from "@circle-react-shared/TippyV2";
import { Typography } from "@circle-react-uikit/Typography";

export interface SelectedTopicProps {
  isDraggable?: boolean;
  isDragging?: boolean;
  isRemovable?: boolean;
  onRemove: () => void;
  topic: Topic;
}

export const SelectedTopic = ({
  topic,
  isDraggable = false,
  isDragging = false,
  isRemovable = false,
  onRemove,
}: SelectedTopicProps) => (
  <TippyV2
    placement="top"
    content={t("quick_post_v2.topics.admin_only")}
    interactive={false}
    disabled={isRemovable}
    trigger="mouseenter click focus focusin"
  >
    <div
      className={classNames(
        "border-primary bg-primary text-dark inline-flex items-center justify-start gap-1.5 whitespace-nowrap rounded-[32px] border py-1.5 pr-2",
        isDragging
          ? "rotate-1 scale-[1.01] opacity-75 shadow-lg"
          : isDraggable
            ? "cursor-move"
            : "cursor-default",
        isRemovable ? "pl-3.5" : "pointer-events-none pl-2",
      )}
    >
      <Typography.LabelXs weight="medium">{topic.name}</Typography.LabelXs>
      {isRemovable && (
        <Icon
          className="cursor-pointer"
          onClick={onRemove}
          type="12-close"
          size={12}
        />
      )}
    </div>
  </TippyV2>
);
